import React, { useState } from "react";
import { Dropdown } from "antd";
import { Column } from "../common/Table/Interfaces";
import Overlay from "./overlay";
import {
  OnChangeColumnCheckbox,
  OnSaveColumnVisibility,
} from "../../interfaces/common";

interface Props extends OnChangeColumnCheckbox, OnSaveColumnVisibility {
  items: Column[];
  children: React.ReactNode;
  className: string;
  overlayClassName: string;
  showToggleAllButton?: boolean;
}

const DropdownToggleItems: React.FC<Props> = ({
  children,
  items,
  onChange,
  saveChanges,
  overlayClassName,
  className,
  showToggleAllButton = false,
}) => {
  const [openDropDown, setOpenDropDown] = useState(false);

  return (
    <Dropdown
      overlay={
        <Overlay
          items={items}
          className={overlayClassName}
          onChange={onChange}
          saveChanges={saveChanges}
          showToggleAllButton={showToggleAllButton}
          isOpenDropDown={openDropDown}
        />
      }
      placement="bottomRight"
      trigger={["click"]}
      className={className}
      onVisibleChange={() => setOpenDropDown(!openDropDown)}
    >
      {children}
    </Dropdown>
  );
};

export default DropdownToggleItems;
